const overviewMenu = function () {
    const $parent = $(".overview-menu");
    const $icon = $parent.find(".overview-icon");
    const $list = $parent.find(".overview-list");
    $icon.on("click", function () {
        const isActive = $list.hasClass("active");
        $list.toggleClass("active");
        anime({
        targets: $list[0],
        height: isActive ? 79 : 400
        });
        $icon.css("transform", `rotate(${isActive ? '0deg' : '180deg'})`)

    })
}

module.exports = overviewMenu